function scrollUpTo(y) {
	const scrollStep = 50 // You can adjust this value to make the scrolling faster or slower
	const currentY = window.pageYOffset
	if (currentY > y) {
		const scrollInterval = setInterval(() => {
			window.scrollBy(0, -scrollStep)
			if (window.pageYOffset <= y) {
				clearInterval(scrollInterval)
			}
		}, 10) // This value represents the time (in milliseconds) between each scroll step
	}
}

export { scrollUpTo }
